import React, { useState } from 'react'; // Import useState for realistic FAQ functionality (though not fully implemented here)
import styled from 'styled-components';
import { FaCheckCircle, FaTimesCircle, FaPlus, FaMinus } from 'react-icons/fa';

// --- Styled Components (Mostly unchanged from previous response, but including modifications for the answer display) ---

const PageContainer = styled.div`
  font-family: Arial, sans-serif;
  color: #333;
  line-height: 1.6;
  background-color: #f7f7f7;
`;

const HeaderTitle = styled.h1`
  text-align: center;
  font-size: 32px;
  padding: 40px 10%;
  margin: 0;
  font-weight: bold;
  color: #000;
`;

// --- Pricing Section Styles (Truncated for brevity, as it's not the focus of this update) ---

const PricingContainer = styled.div`
  display: flex;
  justify-content: center;
  gap: 30px;
  padding: 20px 10%;
  margin-bottom: 60px;

  @media (max-width: 1200px) {
    flex-direction: column;
    align-items: center;
  }
`;

const PackageCard = styled.div`
  flex: 1;
  max-width: 380px;
  background-color: white;
  border-radius: 8px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
  overflow: hidden;
`;

const PackageHeader = styled.div`
  background-color: #d88b0a;
  color: white;
  padding: 25px 20px;
  text-align: center;
`;

// ... other pricing styles ...

// --- FAQ Section Styles ---

const FAQSection = styled.section`
  padding: 40px 10%;
  text-align: center;
  background-color: white;
`;

const FAQTitle = styled.h2`
  font-size: 30px;
  margin-bottom: 40px;
  font-weight: bold;
  color: #000;
`;

const FAQList = styled.div`
  max-width: 900px;
  margin: 0 auto;
  text-align: left;
`;

const FAQItem = styled.div`
  /* Container for the question and answer */
  padding: 15px 0;
  border-top: 1px solid #eee;

  &:last-child {
    border-bottom: 1px solid #eee;
  }
`;

const QuestionRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
`;

const FAQQuestion = styled.p`
  flex-grow: 1;
  margin: 0;
  font-size: 16px;
  color: #333;
  font-weight: 500;
`;

const FAQAnswer = styled.div`
  /* Style for the answer content */
  margin-top: 10px;
  padding: 10px 0 0 0;
  font-size: 15px;
  color: #555;
  border-top: ${props => props.$isOpen ? '1px solid #f0f0f0' : 'none'};
  display: ${props => props.$isOpen ? 'block' : 'none'};
`;

const FAQIcon = styled.span`
  color: #888;
  font-size: 18px;
  cursor: pointer;
  padding-left: 20px;
  display: flex; /* To center the icon */
`;

// --- Footer Section Styles (Truncated for brevity) ---

const FooterBar = styled.footer`
  background-color: #333;
  color: white;
  padding: 30px 10%;
  text-align: center;
`;

const PriceDisplay = styled.div``

const ClientSupportSection = styled.div``
const CTAButton = styled.div``
const TCApply= styled.div``
const FooterText = styled.div``

// ... other footer styles ...

// --- Component Data (Updated with Answers) ---

const packages = [
  // ... (Data for pricing cards remains the same)
];

const clientSupport = ['Email', 'Chat', 'Call'];

const faqsWithAnswers = [
  {
    q: 'What are custom SEO services, and how do they differ from standard SEO packages?',
    a: 'Custom SEO services are tailored strategies designed specifically for your unique business goals, industry, competition, and target audience. Standard packages offer a fixed set of deliverables, whereas custom services, like those offered by **SRK Software**, are flexible and adjust over time to maximize ROI, focusing precisely where your business needs it most.',
  },
  {
    q: 'Why should I choose custom SEO services over pre-packaged ones?',
    a: 'A custom service ensures that every dollar is spent on tactics that directly impact your specific revenue goals. Pre-packaged solutions often include generic activities you may not need or lack the specialized focus required to beat tough competition in your niche. Customization means a stronger, more targeted strategy.',
  },
  {
    q: 'How do you determine the right custom SEO strategy for my business?',
    a: "We begin with an in-depth **SRK Software** audit of your current site, your competitors, and your market landscape. We analyze keywords, technical structure, content gaps, and link profile to identify the highest-leverage opportunities, forming a strategy based on data, not assumptions.",
  },
  {
    q: 'What specific SEO techniques and tactics are included in custom services?',
    a: 'Custom services typically include advanced Technical SEO, strategic On-Page Content Optimization, localized SEO campaigns, high-authority Link Building/Outreach, and conversion rate optimization (CRO) tailored to your industry, ensuring all efforts are aligned with your business objectives.',
  },
  {
    q: 'Can custom SEO services accommodate my budget and business size?',
    a: 'Absolutely. The core benefit of customization is flexibility. **SRK Software** scales the services to fit your budget, whether you are a small local startup needing intense Local SEO or a large e-commerce enterprise requiring extensive technical work and content marketing.',
  },
  {
    q: 'How long does it take to see results with custom SEO services?',
    a: 'While technical fixes and local visibility improvements can show results in **1-3 months**, significant ranking and organic traffic improvements typically take **4-6 months** or longer, depending on your competition and the current state of your website. Custom strategies focus on sustainable, long-term growth.',
  },
  {
    q: 'Will I receive regular progress reports with custom SEO services?',
    a: 'Yes. We provide transparent, detailed monthly reports. These include key performance indicators (KPIs) like keyword ranking movement, organic traffic growth, conversion rates, and a summary of the tasks completed, ensuring you always know the value **SRK Software** is delivering.',
  },
  {
    q: 'How do I get started with custom SEO services for my business?',
    a: "Getting started is easy! Simply click the 'Get Started Now' button on one of our package cards or contact **SRK Software** directly. We'll schedule a discovery call to understand your needs and provide a tailored proposal.",
  },
];

// --- React Component Implementation ---

// Placeholder for PricingCard (assuming the data structure for packages is available)
const PricingCard = ({ pkg }) => {
  // ... (Implementation from previous response)
  return (
    <PackageCard>
        {/* Simplified card structure for context */}
        <PackageHeader>...</PackageHeader>
        <PriceDisplay>...</PriceDisplay>
        <ClientSupportSection>
            <CTAButton href="#">Get Started Now!</CTAButton>
            <TCApply>T&C Apply</TCApply>
        </ClientSupportSection>
    </PackageCard>
  );
};


const FAQComponent = ({ questionData }) => {
  // Using state to realistically toggle the answer view, although the initial image only shows a '+'
  const [isOpen, setIsOpen] = useState(false);

  return (
    <FAQItem>
      <QuestionRow onClick={() => setIsOpen(!isOpen)}>
        <FAQQuestion>
          {questionData.q}
        </FAQQuestion>
        <FAQIcon>
          {/* Toggle icon based on state */}
          {isOpen ? <FaMinus /> : <FaPlus />} 
        </FAQIcon>
      </QuestionRow>
      {/* The Answer component is conditionally rendered based on state */}
      <FAQAnswer $isOpen={isOpen}>
        {questionData.a}
      </FAQAnswer>
    </FAQItem>
  );
};

const LocalSeo3 = () => {
  return (
    <PageContainer>
      {/* Header */}
      <HeaderTitle>Local SEO Packages In India</HeaderTitle>

      {/* Pricing Cards */}
      <PricingContainer>
        {/* Placeholder: Rendering a card for visual context */}
        {packages.slice(0, 3).map((pkg, index) => (
          <PricingCard key={index} pkg={pkg} />
        ))}
      </PricingContainer>

      {/* Frequently Asked Questions Section (Updated with Answers) */}
      <FAQSection>
        <FAQTitle>Frequently Asked Questions</FAQTitle>
        <FAQList>
          {faqsWithAnswers.map((qData, index) => (
            <FAQComponent key={index} questionData={qData} />
          ))}
        </FAQList>
      </FAQSection>

      {/* Follow Us Footer */}
      <FooterBar>
        <FooterText>Follow Us</FooterText>
        <FooterText>
          Stay connected with us on Facebook and Linkedin for the latest updates, insights, and industry news.
        </FooterText>
        {/* ... (Footer buttons) */}
      </FooterBar>
    </PageContainer>
  );
};

export default LocalSeo3;

